export const JukeboxTypes = {
    JUKEBOX_PLAY_YT : 'JUKEBOX_PLAY_YT_JUKEBOX',
    JUKEBOX_STOP_YT : 'JUKEBOX_STOP_YT_JUKEBOX',
    RESET : 'RESET',
};